import { Component, Input, OnInit, SimpleChanges, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as moment from "moment";
import * as _ from "lodash";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-form-histo-validation',
  templateUrl: './form-histo-validation.component.html',
  styleUrls: ['./form-histo-validation.component.scss']
})
export class FormHistoValidationComponent implements OnInit {

listItems: Array<any> = [];
  items: Array<any> = [];
  @Input() selectedNotification:any
  itemToSave: any = {};
  filiale_id:any
  uniteFonctionnelleSelected: any = {};
  modalRef: BsModalRef;
  user: any = {};
  itemToSearch: any = {};
  currentPage: number = 0;
  itemsPerPage: number = 10;
  totalItems: number;
  show_password_field = true
  busyGet: Subscription;
  busySave: Subscription;
  loading: boolean = false;
  itemsStatutNotification=[{code:'EN_ATTENTE',libelle:'En attente'},{code:'VALIDE',libelle:'Validé'},{code:'REJETE',libelle:'Rejeté'}]
  endPoint: string = "etapeValidation";
  title:string='étape de validation'
  createMessage = ''
  editMessage =''
  deleteMessage =''
  itemsParentFonctionnalites=[]

  gender='F'
  itemsRole: any;
  itemsSpecialites: any;
  itemsCivilite:any=[]
  itemsGenre:any=[]
  itemsFiliale:any=[]
  searchKey:any
  dateNais: any;
  bsValue: Date;
  imageName: string;
  imageDisplay: any;
  currentItemImage: {
    fileBase64: any;
    fileName: any;
    extension: any;
    typeDocument: string;
  };
  selectedUniteFoncId: any;
  selectedSpecialiteId: any;
  listSelectedUniteFonctionnelle = [];
  isAutoPassword=false
  maxDate = new Date(
    new Date().getFullYear() - 18,
    new Date().getMonth() - 1,
    new Date().getDay()
  );
  minDate = new Date();
  itemsFucntParent: any[];
  itemsRegion: any;
  itemsVille: any[];
  itemsCommune: any[];
  itemsTypeValidation: any;
  itemsTypeNotification: any;
  itemsUser: any;
  itemsNotification: any;
  constructor(
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService,
    private sanitizer: DomSanitizer
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser()
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id
    let text1 = this.gender=='M'?'un':'une'
    this.createMessage = 'Vous êtes sur le point de créer '+text1+' '+this.title
    this.editMessage = 'Vous êtes sur le point de modifier '+text1+' '+this.title
    this.deleteMessage = 'Vous êtes sur le point de supprimer '+text1+' '+this.title


  }

  ngOnChanges(changes: SimpleChanges) {
      console.log('change: ',changes)
      if (changes.selectedNotification && changes.selectedNotification.currentValue) {
        
        setTimeout(() => {

          this.getItems()
        });
      }
    }

  pageChanged(event: any): void {
    this.currentPage = event.page-1;
    this.getItems();
  }
  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
  }

  

  openModal(data: any, template: TemplateRef<any>) {
    
    let config = {
      backdrop: true,
      ignoreBackdropClick: true,
      id: 1,
      // class: "modal-lg",
      class: "gray modal-lg modal-width-60",
    };
    this.itemToSave = {};
    if (data) {
 
      this.itemToSave = Object.assign({}, data);
    }

    this.modalRef = this.modalService.show(template, config);
  }

  saveItem(item) {
    console.info("item to save", item);

    this.loading = true;

    let itemAEnregistrer = Object.assign({}, item);
    let reduce = [];
    itemAEnregistrer.filiale_id = this.filiale_id || this.user.filiale_id
    var request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      datas: [itemAEnregistrer],
    };

    this.busySave = this.restClient
      .post(
        this.endPoint + "" + (itemAEnregistrer.id ? "/update" : "/create"),
        request
      )
      .subscribe(
        (res) => {
          console.info("resul", res);
          this.loading = false;

          if (!res["hasError"]) {
              this.utilities.showNotification(
                "snackbar-success",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );

              this.getItems();
              this.modalRef.hide();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
          this.loading = false;
        }
      );
  }

  getItems() {
    if(!this.selectedNotification || !this.selectedNotification.id) return
    let request = {
      user_id: this.user.id,
      filiale_id:this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      order_by:'ordre',
      data: {
        notification_id:this.selectedNotification.id,
      },
      index: this.currentPage,
      size: this.itemsPerPage,
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res['hasError']) {
            this.items = res["items"];
            
            this.totalItems = res["count"];
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.items = [];
            this.totalItems = 0;
          }
        },
        (err) => { }
      );
  }


  getItemsFiliale() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("filiale/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsFiliale", res);

          if (res && res["items"]) {
            this.itemsFiliale = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsFiliale = [];
          }
        },
        (err) => { }
      );
  }

  getItemsCommune() {
    let request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("commune/getByCriteria", request)
      .subscribe(
        (res) => {
          console.info("itemsCommune", res);

          if (res && res["items"]) {
            this.itemsCommune = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );
          } else {
            this.itemsCommune = [];
          }
        },
        (err) => { 
          this.itemsCommune = [];
        }
      );
  }

  confirmDelete(item) {
    Swal.fire({
      title: this.capitalize(this.title),
      text: this.deleteMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3f51b5",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
    }).then((result) => {
      if (result.value) {
        this.deleteItem(item);
      }
    });
  }

  deleteItem(obj) {
    var request = {
      user_id: this.user.id,
      filiale_id:this.user.filiale_id,
      datas: [obj],
    };

    this.busyGet = this.restClient
      .post(this.endPoint + "/delete", request)
      .subscribe(
        (res) => {
          console.info(res);
          if (!res["hasError"]) {
            this.utilities.showNotification(
              "snackbar-success",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );

            this.currentPage = 0;
            this.getItems();
          } else {
            if (res["status"] && res["status"]["message"]) {
              this.utilities.showNotification(
                "snackbar-danger",
                this.utilities.formatMsgServeur(res["status"]["message"]),
                "bottom",
                "center"
              );
            }
          }
        },
        (err) => {
          console.info("Error occured", err);
          this.utilities.showNotification(
            "snackbar-danger",
            this.utilities.getMessageEndPointNotAvailble(),
            "bottom",
            "center"
          );
        }
      );
  }

  onSelectDate(event) {
    if (event) {
      (this.dateNais = moment(event).format("DD/MM/YYYY")),
        console.info("dateNais", this.dateNais);
    }
  }

  

  

  

  changePaginationSize($event) {
    if ($event) {
      this.currentPage = 0;
      this.itemsPerPage = parseInt($event);
    }
    this.getItems();
  }

  isValidEmail(email) {
    // Regular expression for validating email addresses
    var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
}

generateUniqueString() {
  // Get current timestamp in milliseconds
  var timestamp = new Date().getTime();

  // Generate a random number
  var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

  // Concatenate timestamp and random number
  var uniqueString = timestamp.toString() + randomNumber.toString();

  return uniqueString;
}



capitalize(str) {
  return str.replace(/^\w/, (c) => c.toUpperCase());
}

load_filiale_data(){
  this.getItems();
    // this.getItemsFiliale();
  this.getItemsCommune()
}

getItemsNotification() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("notification/getByCriteria", request)
    .subscribe(
      (res) => {
        console.info("itemsNotification", res);

        if (res && res["items"]) {
          this.itemsNotification = _.orderBy(
            res["items"],
            ["libelle"],
            ["asc"]
          );
        } else {
          this.itemsNotification = [];
        }
      },
      (err) => { }
    );
}
getItemsUser() {
  let request = {
    user_id: this.user.id,
    filiale_id:this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("user/getByCriteria", request)
    .subscribe(
      (res) => {
        console.info("itemsUser", res);

        if (res && res["items"]) {
          this.itemsUser = _.orderBy(
            res["items"],
            ["nom"],
            ["asc"]
          );
        } else {
          this.itemsUser = [];
        }
      },
      (err) => { }
    );
}

getItemsRoles() {
  console.info("getting data");
  let request = {
    user_id: this.user.id,
    filiale_id:this.filiale_id || this.user.filiale_id,
    index: 0,
    size: 1000,
    data: {},
  };

  this.busyGet = this.restClient
    .post("role/getByCriteria", request)
    .subscribe(
      (res) => {
        console.info("itemsRole", res);

        if (res && res["items"]) {
          this.itemsRole = _.orderBy(res["items"], ['libelle']);
        } else {
          this.itemsRole = [];
        }
      },
      (err) => { }
    );
}


  ngOnInit() {
    this.resetForm();
    this.getItems();
    this.getItemsFiliale();
    this.getItemsRoles()
    this.getItemsUser()
    this.getItemsNotification()
  }

}
